import type { MaloupeCategoryDto } from '@malou-io/package-dto';
import type { MaloupeLocale } from '@malou-io/package-utils';

export class Category {
    id: string;
    categoryName: {
        backup: string;
        fr?: string | null;
        en?: string | null;
        es?: string | null;
        it?: string | null;
    };
    categoryId: string;

    public constructor(init: Category | MaloupeCategoryDto) {
        this.id = init.id;
        this.categoryName = init.categoryName;
        this.categoryId = init.categoryId;
    }

    getCategoryNameForLang(lang: MaloupeLocale): string {
        return this.categoryName[lang] || this.categoryName.backup;
    }
}
